//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { AssetFeedsModalActionType } from '@streams/actions/assetFeedsModalActions';
import { ASSET_FEEDS_MODAL_ACTIONS } from '@streams/constants/assetFeedsModalConstants';
import { IAssetFeedsModal } from '@streams/models/assetFeedsModalStateModel';

const initialState: IAssetFeedsModal = {
  isUpdatingSources: false,
  isUpdatingFilters: false,
  isEditingSources: false,
  instagramBusinessId: null,
  sourceSettings: {
    facebook: false,
    instagram: false,
    ugc: false,
    uploaded: false,
  },
  sourceConnectionStates: {
    facebook: false,
    instagram: false,
  },
};

export default function AssetFeedsModalReducer(
    state: IAssetFeedsModal = initialState,
    action: AssetFeedsModalActionType,
): IAssetFeedsModal {
  switch (action.type) {
    case ASSET_FEEDS_MODAL_ACTIONS.SET_ASSET_FEEDS_STREAM_SOURCE: {
      return {
        ...state,
        sourceSettings: {
          ...state.sourceSettings,
          [action.mediaSource]: action.value
        }
      };
    }
    case ASSET_FEEDS_MODAL_ACTIONS.SET_ASSET_FEEDS_SOURCE_CONNECTION_STATE: {
      return {
        ...state,
        sourceConnectionStates: {
          ...state.sourceConnectionStates,
          [action.mediaSource]: action.value
        }
      };
    }
    case ASSET_FEEDS_MODAL_ACTIONS.SET_UPDATING_SOURCES: {
      return {
        ...state,
        isUpdatingSources: action.isUpdatingSources
      };
    }
    case ASSET_FEEDS_MODAL_ACTIONS.SET_UPDATING_FILTERS: {
      return {
        ...state,
        isUpdatingFilters: action.isUpdatingFilters,
      };
    }
    case ASSET_FEEDS_MODAL_ACTIONS.SET_INSTAGRAM_BUSINESS_USER_ID: {
      return {
        ...state,
        instagramBusinessId: action.instagramBusinessId
      };
    }
    case ASSET_FEEDS_MODAL_ACTIONS.SET_EDITING_SOURCES: {
      return {
        ...state,
        isEditingSources: action.isEditingSources
      };
    }
    default:
      return state;
  }
}
